export const Youtube = () => {
  return (
    <svg
      width="32"
      height="23"
      viewBox="0 0 32 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.3313 3.52048C30.9633 2.13474 29.879 1.04338 28.5022 0.673007C26.0067
          0 16 0 16 0C16 0 5.99337 0 3.49781 0.673007C2.12103 1.04344 1.0367 2.13474
          0.668671 3.52048C0 6.03222 0 11.2727 0 11.2727C0 11.2727 0 16.5132 0.668671
          19.0249C1.0367 20.4107 2.12103 21.4566 3.49781 21.827C5.99337 22.5 16 22.5
          16 22.5C16 22.5 26.0066 22.5 28.5022 21.827C29.879 21.4566 30.9633 20.4107
          31.3313 19.0249C32 16.5132 32 11.2727 32 11.2727C32 11.2727 32 6.03222 31.3313
          3.52048ZM12.7273 16.0307V6.51473L21.0909 11.2728L12.7273 16.0307Z"
        fill="#051C2C"
      />
    </svg>
  )
}
